module.exports = __webpack_public_path__ + "static/media/graphOff_118.590d3078.png";